
































import pageMixin from '@bkwld/cloak/mixins/page'
import getCraftPages from '~/queries/craft-pages.gql'
import {
	getShopifyDataForCraftProduct,
	makeBundleCurrentVariant,
} from 'library/helpers/products'
import { makeJsonLdProductTag } from '@bkwld/json-ld-formatters'
export default
	name: 'PDP'

	provide:
		onPDP: true

	mixins: [ pageMixin ]

	# Metadata
	head: -> {
		...@buildHead
			title: @product.title
			description: @product.description
			image: @primaryImage
			canonical: process.env.URL + '/' + @product.uri
		script: [ makeJsonLdProductTag
			name: @product.title
			image: @primaryImage
			description: @product.description
			sku: @currentVariant.sku
			url: @currentVariant.url
			price: @currentVariant.price.amount
			available: @currentVariant.available
		]
	}

	data: ->
		loading: true

	# Get Product data
	asyncData: ({ app, store, params, payload }) ->

		# Get product data
		[ product ] = payload || await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'products'
				uri: "products/#{params.product}"
		return app.$notFound() unless product

		# Augment product with extra Shopify data
		try product = {
			...product
			...(await getShopifyDataForCraftProduct product)
		}

		# Shopify data is required, so 404 when not found
		catch error
			console.error error
			return app.$notFound()

		# Check that the deep linked variant exists in data
		if params.variant and !product.variants.find (variant) ->
			params.variant == app.$getShopifyId variant.id
		then return app.$notFound()

		# Set the initial variant
		currentVariant = switch

			# If a bundle, make a fake currentVariant
			when product.isBundle then makeBundleCurrentVariant product

			# No variant in URL, so default to first variant
			when !params.variant then product.variants[0]

			# Set to variant that was in the URL
			else product.variants.find (variant) =>
				params.variant == app.$getShopifyId variant.id

		# Set data
		return { product, currentVariant }

	mounted: ->

		# if a bundle, then don't try to grab shopify data
		if @product.isBundle
			@loading = false
			return

		updatedProduct = await getShopifyDataForCraftProduct @product

		@product = {
			...@product
			...updatedProduct
		}

		@loading = false

	computed:

		bannerText: -> @$store.state.globals.productFields?.bannerText

		# This will be used by head-tags via pageMixin
		page: -> @product

		# Make an image ref that can be used for og:image or json-ld
		primaryImage: -> @currentVariant?.image?.src

		# Make the GTM payload for product impression
		bundleImpressionPayload: ->
			return unless @product.isBundle
			event: 'Product Impression'
			sku: @product.slug
			variantId: @currentVariant.id
			variantTitle: @currentVariant.title
			variantImage: @currentVariant.image
			variantUrl: @currentVariant.url
			price: @currentVariant.price.amount
			compareAtPrice: @currentVariant.compareAtPrice.amount
			productId: @product.id
			productTitle: @product.title
			productVariantTitle: @product.title
			productType: @product.productType
			productVendor: @product.vendor
			productUrl: @product.url

	watch:

		# Fire GTM event on variant change
		currentVariant:
			immediate: true
			handler: ->
				if @product.isBundle
				then @$gtm?.push @bundleImpressionPayload
				else @$gtmEcomm.viewProductDetails @currentVariant.id

